export enum FileTypeEnum {
  /**
   * fiches de poste / financière, uniquement obligatoire pour les BIATOSS
   */
  poste = 1,
  financiere = 2,
  autre = 3,

  /**
   * autres pièce à joindre, spécifique à la "recherche"
   */
  pi = 10,
  cvitale = 11,
  rib = 12,
  dombank = 13,
  casier = 14,

  /* pour le recrutement*/
  cv = 15,

  /* modeles de pj financières */
  modelFinVacHor = 100,
  modelFinLessYear = 101,
  modelFinMoreYear = 102
}


interface HelperPieceJointeLabel {
  label: string;
  labelJoin: string;
}

const piecesJointes: { [id: number]: HelperPieceJointeLabel; } = {};
piecesJointes[FileTypeEnum.poste] = {label: 'Fiche de poste' , labelJoin: 'Joindre la fiche de poste'};
piecesJointes[FileTypeEnum.financiere] = {label: 'Fiche financière' , labelJoin: 'Joindre la fiche financière'};
piecesJointes[FileTypeEnum.autre] = {label: 'Autre' , labelJoin: 'Joindre un autre document (convention financière, argumentaire, etc)'};
piecesJointes[FileTypeEnum.pi] = {label: 'Pièce d\'identité' , labelJoin: 'Joindre la pièce d\'identité'};
piecesJointes[FileTypeEnum.cvitale] = {label: 'Carte vitale' , labelJoin: 'Joindre la carte vitale'};
piecesJointes[FileTypeEnum.rib] = {label: 'R.I.B.' , labelJoin: 'Joindre le R.I.B.'};
piecesJointes[FileTypeEnum.dombank] = {label: 'Domiciliation bancaire' , labelJoin: 'Joindre la domiciliation bancaire'};
piecesJointes[FileTypeEnum.casier] = {label: 'Casier judiciaire' , labelJoin: 'Joindre l\'extrait du casier judiciaire'};
piecesJointes[FileTypeEnum.cv] = {label: 'C.V.' , labelJoin: 'Joindre le C.V.'};

piecesJointes[FileTypeEnum.modelFinVacHor] = {label: 'Modèle de la fiche financière vacation horaire' , labelJoin: 'Modèle de la fiche financière vacation horaire'};
piecesJointes[FileTypeEnum.modelFinLessYear] = {label: 'Modèle de la fiche financière contrat de moins d\'un an' , labelJoin: 'Modèle de la fiche financière contrat de moins d\'un an'};
piecesJointes[FileTypeEnum.modelFinMoreYear] = {label: 'Modèle de la fiche financière contrat de plus d\'un an' , labelJoin: 'Modèle de la fiche financière contrat de plus d\'un an'};

export function fileTypeEnumLabelJoin(typeFile: FileTypeEnum, mandatory: boolean, sizeFile: number) {
  const taille = `(la taille ne doit pas dépasser ${sizeFile} Mo)`;
  const label = piecesJointes[typeFile].labelJoin;

  if (mandatory && typeFile === FileTypeEnum.poste) {
    return `<span class="mandatory-field">*</span> ${label} ${taille}`;
  }
  return `${label} ${taille}`;
}

export function fileTypeEnumLabel(typeFile: FileTypeEnum) {
  return piecesJointes[typeFile].label;
}
